<div class="data">
  <table>
    <tr>
      <td colspan="2" class="label">{{contact.key?.toUpperCase() | translate}}</td>
    </tr>
    <tr>
      <td class="icon">
        <i class="fa fa-phone" aria-hidden="true"></i>
      </td>
      <td class="value">
        <a href="tel:{{phoneNumber}}" *ngFor="let phoneNumber of phoneNumbers">{{phoneNumber}}</a>
      </td>
    </tr>
    <tr>
      <td class="icon">
        <i class="fa fa-envelope-open" aria-hidden="true"></i>
      </td>
      <td class="value">
        <a href="mailto:{{emailAddress}}"  *ngFor="let emailAddress of emailAddresses">{{emailAddress}}</a>
      </td>
    </tr>
  </table>
</div>

